"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function About() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="about" className="py-spacing-xl">
      <div className="container mx-auto px-spacing-md">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-spacing-lg">
          {}
          <div ref={ref1} className={`flex flex-col justify-center transition-all duration-[var(--duration-medium)] ${isVisible1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="text-primary mb-spacing-md">Personalized Mentorship</h2>
            <p className="text-foreground mb-spacing-sm leading-relaxed">At Sundaram's School of Commerce, we believe that every learner deserves individualized attention. Our faculty members bring over 15 years of experience in education innovation, ensuring that each student receives tailored guidance to unlock their full potential.</p>
            <p className="text-muted-foreground leading-relaxed">Through one-on-one sessions and collaborative classes, our faculties foster an environment where curiosity thrives and academic excellence becomes second nature.</p>
          </div>

          <div ref={ref2} className={`transition-all duration-[var(--duration-medium)] ${isVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <Card className="overflow-hidden border-border-strong shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1545674/img/personalized_mentorship_session.png" alt="Personalized Mentorship Session" className="w-full h-80 object-cover" />
            </Card>
          </div>

          {}
          <div ref={ref3} className={`lg:order-2 flex flex-col justify-center transition-all duration-[var(--duration-medium)] ${isVisible3 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="text-secondary mb-spacing-md">Student Achievement</h2>
            <p className="text-foreground mb-spacing-sm leading-relaxed">Our rigorous coaching prepare CA Students for the challenges of tomorrow. Our students consistently excel in their fields, thanks to our interactive curricula and supportive learning environment.</p>
            <p className="text-muted-foreground leading-relaxed"><br /></p>
          </div>

          <div ref={ref4} className={`lg:order-1 transition-all duration-[var(--duration-medium)] ${isVisible4 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <Card className="overflow-hidden border-border-strong shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1545674/img/student_achievement_moment.png" alt="Student Achievement Moment" className="w-full h-80 object-cover" />
            </Card>
          </div>
        </div>

        {}
        <div className="mt-spacing-xl max-w-4xl mx-auto text-center">
          <h3 className="text-primary mb-spacing-md">Modern Pedagogy for a Future-Ready Generation</h3>
          <p className="text-foreground leading-relaxed mb-spacing-sm">Sundaram's School of Commerce (SSC) combines state-of-the-art facilities with innovative teaching methods to create a holistic learning experience. Our commitment to academic excellence ensures that every student is prepared for success.</p>
          <p className="text-muted-foreground leading-relaxed">Join us at PLOT NO.3, SUNDARA ILLAM, ANANDARAJA NAGAR 1ST CROSS, S.KODIKULAM, MADURAI - 625007 and discover how SSC can transform your educational journey. Contact us at 94864 88262 or visit us Monday through Saturday, 10am to 6pm.</p>
        </div>
      </div>
    </section>;
}